import { SvgIcon } from '@material-ui/core'

export default function CameraIcon(props: any) {
    return (
        <SvgIcon style={{ width: '28px', height: '28px' }} viewBox="0 0 28 28" fill="none" {...props}>
            <foreignObject x="-45.7079" y="-44.5304" width="119.419" height="115.895"></foreignObject>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.0016 3.5L22.4875 3.73993C23.9869 3.78232 25.2271 4.92059 25.3976 6.41089C25.7751 9.70977 25.7751 13.0409 25.3976 16.3398C25.2271 17.8301 23.9869 18.9684 22.4875 19.0108L15.46 19.2095V21.5837H19.835C20.3182 21.5837 20.71 21.9754 20.71 22.4587C20.71 22.9419 20.3182 23.3337 19.835 23.3337H8.1683C7.68506 23.3337 7.2933 22.9419 7.2933 22.4587C7.2933 21.9754 7.68506 21.5837 8.1683 21.5837H12.5433V19.2095L5.51572 19.0108C4.0163 18.9684 2.77611 17.8301 2.60559 16.3398C2.22815 13.0409 2.22815 9.70977 2.60559 6.41088C2.77611 4.92059 4.0163 3.78232 5.51572 3.73993L14.0016 3.5ZM5.83497 15.167C5.35172 15.167 4.95997 15.5588 4.95997 16.042C4.95997 16.5253 5.35172 16.917 5.83497 16.917H22.1683C22.6516 16.917 23.0433 16.5253 23.0433 16.042C23.0433 15.5588 22.6516 15.167 22.1683 15.167H5.83497Z"
                fill="url(#paint0_linear_1373_15963)"
            />
            <defs>
                <clipPath id="bgblur_0_1373_15963_clip_path" transform="translate(45.7079 44.5304)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.0016 3.5L22.4875 3.73993C23.9869 3.78232 25.2271 4.92059 25.3976 6.41089C25.7751 9.70977 25.7751 13.0409 25.3976 16.3398C25.2271 17.8301 23.9869 18.9684 22.4875 19.0108L15.46 19.2095V21.5837H19.835C20.3182 21.5837 20.71 21.9754 20.71 22.4587C20.71 22.9419 20.3182 23.3337 19.835 23.3337H8.1683C7.68506 23.3337 7.2933 22.9419 7.2933 22.4587C7.2933 21.9754 7.68506 21.5837 8.1683 21.5837H12.5433V19.2095L5.51572 19.0108C4.0163 18.9684 2.77611 17.8301 2.60559 16.3398C2.22815 13.0409 2.22815 9.70977 2.60559 6.41088C2.77611 4.92059 4.0163 3.78232 5.51572 3.73993L14.0016 3.5ZM5.83497 15.167C5.35172 15.167 4.95997 15.5588 4.95997 16.042C4.95997 16.5253 5.35172 16.917 5.83497 16.917H22.1683C22.6516 16.917 23.0433 16.5253 23.0433 16.042C23.0433 15.5588 22.6516 15.167 22.1683 15.167H5.83497Z"
                    />
                </clipPath>
                <linearGradient
                    id="paint0_linear_1373_15963"
                    x1="9.06943"
                    y1="3.44971"
                    x2="9.06942"
                    y2="30.0819"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
            </defs>
        </SvgIcon>
    )
}
